import React from 'react';
import { alpha, Box, Tooltip } from '@mui/material';
import useBundleTranslation from 'i18n';

// Marks a knowledge-graph resource Concierge does not serve: not published yet, or deleted while an
// insight still stores it. Sits beside the option name in the menu and on the selected value.
export default function ResourceStateChip({ state }: { state: 'unpublished' | 'deleted' }) {
    const { t } = useBundleTranslation('app/editor/element/extreport');
    const palette = 'deleted' === state ? 'error' : 'warning';
    return (
        <Tooltip title={t(`concierge_resource_${state}_tip`)}>
            <Box
                component="span"
                data-test={`concierge_resource_${state}_chip`}
                sx={(theme) => ({
                    display: 'inline-flex',
                    alignItems: 'center',
                    ml: 1,
                    px: '6px',
                    height: '18px',
                    borderRadius: '9px',
                    fontSize: '11px',
                    lineHeight: '16px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    color: theme.palette[palette].dark,
                    bgcolor: alpha(theme.palette[palette].main, 0.12),
                    verticalAlign: 'middle',
                })}
            >
                {t(`concierge_resource_${state}_chip`)}
            </Box>
        </Tooltip>
    );
}
